import { httpGet } from 'utils';
import { ManagementFeeType } from '../types';

interface ManagementFeeResponse {
  data: ManagementFeeType[];
  size?: number;
}

export const fetchManagementFees = () => httpGet<ManagementFeeResponse>('portal/ManagementFees');
